// Keep tone marks attached to their letters; never synthesize/reposition accents.
export const normalizePinyin = (value: string): string => value.normalize('NFC');
export function isPinyinChoice(value: string): boolean {
  return /[a-zü]/iu.test(value.normalize('NFD')) && /^[a-zü\u0300-\u036f\s’'.,?!…-]+$/iu.test(value.normalize('NFD'));
}
